var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9992C11.8684 16 11.7379 15.9748 11.6161 15.925C11.4943 15.8752 11.3834 15.8019 11.29 15.7092L5.29 9.70952C5.1017 9.52123 4.99591 9.26585 4.99591 8.99956C4.99591 8.73327 5.1017 8.47789 5.29 8.28959C5.47831 8.1013 5.7337 7.99552 6 7.99552C6.2663 7.99552 6.5217 8.1013 6.71 8.28959L12 13.5893L17.29 8.29959C17.4813 8.13577 17.7274 8.05017 17.9791 8.05989C18.2307 8.06961 18.4695 8.17394 18.6476 8.35203C18.8257 8.53011 18.93 8.76884 18.9397 9.0205C18.9494 9.27217 18.8638 9.51823 18.7 9.70952L12.7 15.7092C12.5137 15.894 12.2623 15.9981 12 15.9992Z",
    fill: "#49028E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectRightIcon);
export default __webpack_public_path__ + "static/media/select-right-icon.ff0be0920de50aaa93b95acb6ff9b494.svg";
export { ForwardRef as ReactComponent };